/**
 * Check if a given value is a valid number.
 * @param {number|string} value - value to test
 * @returns {boolean} - returns true or false
 */
export default function isNumber(value) {
  return typeof value === 'number' && isFinite(value) && !isNaN(value)
}
